// extracted by mini-css-extract-plugin
export var core_values_container = "CoreValues-module--core_values_container--1a29b";
export var left_line = "CoreValues-module--left_line--4f51f";
export var value_card = "CoreValues-module--value_card--9d8b6";
export var value_details = "CoreValues-module--value_details--01b2f";
export var value_group = "CoreValues-module--value_group--7555b";
export var value_group__experience = "CoreValues-module--value_group__experience--e5eee";
export var value_group__grow = "CoreValues-module--value_group__grow--c55f0";
export var value_group__impact = "CoreValues-module--value_group__impact--a1bc1";
export var value_group__team_work = "CoreValues-module--value_group__team_work--f3c80";
export var value_group__transparency = "CoreValues-module--value_group__transparency--7e8b2";
export var value_text = "CoreValues-module--value_text--36592";
export var value_title = "CoreValues-module--value_title--44399";
export var values = "CoreValues-module--values--a9841";